import { render, staticRenderFns } from "./featuresTwo.vue?vue&type=template&id=f4f28da2&"
import script from "./featuresTwo.vue?vue&type=script&lang=js&"
export * from "./featuresTwo.vue?vue&type=script&lang=js&"
import style0 from "./featuresTwo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports